var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#FFF"},React.createElement("g",null,[React.createElement("path",{"d":"M-4 12H30V14.125H-4z","transform":"translate(-498 -41) translate(498 41) rotate(-45 13 13.063)","key":0}),React.createElement("path",{"d":"M-4 12H30V14.125H-4z","transform":"translate(-498 -41) translate(498 41) rotate(45 13 13.063)","key":1})]))));
}

CloseIconInline.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
